import axios from 'axios';
import envData from 'env.json';
import {Platform} from 'react-native';

const {API_URL, USE_STORYBOOK} = envData;
export enum APICallState {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  RETRYING = 'RETRYING',
}

export interface ResponseHeader {
  header: {resultCode?: string; resultStatus?: string; resultMessage?: string};
}

export interface ResponseError {
  resultCode: string;
  resultMessage: string;
}

// TODO: Switch this back to pbtrproxy once pbtrproxy has been updated for the leapintegration APIs
// Ref: https://caesarsdevelopment.atlassian.net/browse/ECOMM-1170
// old version:
// const PROXY_NAME = Platform.OS === 'web' ? 'proxy' : 'pbtrproxy';
const PROXY_NAME = 'proxy';
export const PROXY_BASE_URL = `/asp_net/${PROXY_NAME}.aspx`;
export const SAP_PROXY_BASE_URL = '/asp_net/sapproxy.aspx';

export const isProduction: boolean = API_URL === 'https://www.caesars.com';
export const isStaging: boolean = API_URL === 'https://stage4.caesars.com';

const api =
  Platform.OS === 'web'
    ? axios.create({
        baseURL: '',
      })
    : axios.create({
        baseURL: API_URL,
      });

export default api;
